<div
    class="px-4 py-2 flex flex-row gap-2 border first:rounded-t-lg last:rounded-b-lg hover:cursor-pointer hover:bg-slate-200"
    [ngClass]="isSelected() ? 'bg-slate-300' : ''">
    <ng-content></ng-content>
</div>
